export * as senderDetails from '@wix/auto_sdk_sender-details_sender-details/meta';
